import { createContext } from "react";

import type { MainBannerTranslations } from "./MainBannerTranslationProvider";

export const mainBannerProvider = createContext<MainBannerTranslations | null>(
  null,
);
